import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Redirect } from "react-router-dom";
import AddCompanyForm from "./addCompanyForm";
import {
  updateState,
  inputErrorClass,
  validateOnlyAphabetsInput,
} from "../../../Global/CustomFunctions";
import * as companyActions from "../companyActions";
import * as accountActions from "../../accounts/accountActions";
import { Common } from "../../../../utils";
import { isSuperAdminRole } from "../../../../utils/superAdminContext";
class AddCompany extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      company: props.company,
      companyErrors: props.companyErrors,
      loader: false,
    };
    this.updateState = this.updateState.bind(this);
    this.redirect = this.redirect.bind(this);
  }
  componentWillMount() {
    if (!isSuperAdminRole()) return;
    this.props.companyActions.clearCmpErrors();
  }
  componentDidMount() {
    if (!isSuperAdminRole()) return;
    this.props.accountActions.onGetSuperAdminRoles();
  }
  onSubmitBtnClick(values) {
    if (!isSuperAdminRole()) return;
    const { onRegisterBySuperAdmin } = this.props.accountActions;
    onRegisterBySuperAdmin(values);
    //  this.setState({ loader: true });
    //  this.props.companyActions
    //    .addCompany(company)
    //    .then(res => {
    //      this.setState({ loader: false });
    //      if (res.success) {
    //        let tempCmp = this.state.company;
    //        tempCmp.Name = "";
    //        this.setState({ company: tempCmp });
    //        Common.showSuccessMessage("Company Created Successfully");
    //        this.redirect();
    //      } else {
    //        Common.showErrorMessage(res.message);
    //      }
    //    })
    //    .catch(error => {
    //      this.setState({ loader: false });
    //      Common.showErrorMessage("Something went wrong, please try again");
    //      console.log(error);
    //    });
  }
  updateState(event) {
    let result = updateState(
      event,
      this.state.company,
      this.state.companyErrors
    );
    this.setState({ company: result });
  }
  redirect() {
    this.props.history.push("/");
  }

  render() {
    if (!isSuperAdminRole()) {
      return <Redirect to="/dashboard" />;
    }
    const { isLoading, roles } = this.props;
    return (
      <AddCompanyForm
        company={this.state.company}
        onChange={this.updateState}
        companyErrors={this.state.companyErrors}
        inputErrorClass={inputErrorClass}
        onCancel={this.redirect}
        roles={roles}
        onSubmitBtnClick={(values) => this.onSubmitBtnClick(values)}
        isLoading={isLoading}
      />
    );
  }
}
const mapStateToProps = ({ companyReducer, accountReducer }) => {
  const { company, companyErrors } = companyReducer;
  const { isLoading, roles } = accountReducer;
  return { company, companyErrors, isLoading, roles };
};
const mapDispatchToProps = (dispatch) => {
  return {
    companyActions: bindActionCreators(companyActions, dispatch),
    accountActions: bindActionCreators(accountActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddCompany);
